// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widgets-partnership-box {
  width: 100%;
  height: 100%;
  background-color: white;
  border-radius: 10px;
  padding: 15px;
  box-sizing: border-box;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  overflow-y: auto;
  color: #617980;
}
.widgets-partnership-box .widgets-partnership-box-program-name {
  color: #062229;
  font-size: 14px;
  display: grid;
  grid-template-columns: 1fr 110px;
  justify-content: space-between;
  align-items: center;
}
.widgets-partnership-box .widgets-partnership-box-program-name .widgets-partnership-box-program-link {
  color: #40A0C1;
  cursor: pointer;
}
.widgets-partnership-box .widgets-partnership-separator {
  height: 1px;
  width: 100%;
  background-color: #D3E1ED;
  margin: 6px 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/Widgets/ProgramCategoryBox/ProgramCategoryBox.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AACD;AACC;EACC,cAAA;EACA,eAAA;EACA,aAAA;EACA,gCAAA;EACA,8BAAA;EACA,mBAAA;AACF;AACE;EACC,cAAA;EACA,eAAA;AACH;AAGC;EACC,WAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;AADF","sourcesContent":[".widgets-partnership-box {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: white;\n\tborder-radius: 10px;\n\tpadding: 15px;\n\tbox-sizing: border-box;\n\tfont-size: 14px;\n\tdisplay: flex;\n\tflex-direction: column;\n\trow-gap: 5px;\n\toverflow-y: auto;\n\tcolor: #617980;\n\n\t.widgets-partnership-box-program-name {\n\t\tcolor: #062229;\n\t\tfont-size: 14px;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 110px;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\n\t\t.widgets-partnership-box-program-link {\n\t\t\tcolor: #40A0C1;\n\t\t\tcursor: pointer;\n\t\t}\n\t}\n\n\t.widgets-partnership-separator {\n\t\theight: 1px;\n\t\twidth: 100%;\n\t\tbackground-color: #D3E1ED;\n\t\tmargin: 6px 0;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
